import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login } from '../api/api';
import './AdminLogin.css';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(username, password);
      loginUser(data.username);
      navigate('/admin');
    } catch (err) {
      const msg = err.response?.data?.message;
      if (msg && (msg.includes('locked') || msg.includes('Too many'))) {
        setError(msg);
      } else {
        setError('Geçersiz kullanıcı adı veya şifre.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="login-card">
        <div className="login-tape" />
        <h1 className="login-title">giriş</h1>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>kullanıcı adı</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>şifre</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'giriş yapılıyor...' : 'giriş yap'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
